import { render, staticRenderFns } from "./TaskDetailsCard.vue?vue&type=template&id=18e8e788&scoped=true"
import script from "./TaskDetailsCard.vue?vue&type=script&lang=js"
export * from "./TaskDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailsCard.vue?vue&type=style&index=0&id=18e8e788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8e788",
  null
  
)

export default component.exports